import { CSSProperties, MutableRefObject, ReactNode } from 'react'

export type TransitionDirection = 'auto' | 'inverse' | 1 | -1

export type AnimationName =
  | 'none'
  | 'slide'
  | 'slideRtl'
  | 'slideFade'
  | 'zoomFade'
  | 'slideLayers'
  | 'fade'
  | 'pushSlide'
  | 'reveal'
  | 'slideOptimized'
  | 'slideOptimizedRtl'
  | 'semiFade'
  | 'slideVertical'
  | 'slideVerticalFade'

export const FALLBACK_ANIMATION_END = 1000

export const CLASSES = {
  slide: 'Transition_slide',
  active: 'Transition_slide-active',
  from: 'Transition_slide-from',
  to: 'Transition_slide-to',
  inactive: 'Transition_slide-inactive',
  invisible: 'Transition_slide-invisible',
}

export interface TransitionProps {
  id?: string
  ref?: MutableRefObject<HTMLDivElement>
  activeKey: number
  name: AnimationName
  direction?: TransitionDirection
  renderCount?: number
  keepAllMounted?: boolean
  keepDisplayMap?: Record<number, boolean>
  className?: string
  slideClassName?: string
  styles?: CSSProperties
  slideStyles?: CSSProperties
  children: ReactNode
}
